 <template>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column prop="date" label="日期" width="180"> </el-table-column>
    <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
    <el-table-column prop="address" label="地址">
      <template slot-scope="scope">
        <el-form :model="scope.row" :rules="rules" :ref="'form' + scope.$index">
          <el-form-item prop="address">
            <el-input v-model="scope.row.address"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submit(scope.$index)">提交</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
  </el-table>
</template>

  <script>
export default {
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "",
        },
      ],
      rules: {
        address: [{ required: true }],
      },
    };
  },
  methods: {
    submit(index) {
      this.$refs['form'+index].validate((valid) => {
        {
          if (valid) {
            console.log(123);
          }
        }
      });
    },
  },
};
</script>